import React from 'react'
import Accordions from '../../../components/Accordions'


const Sem2Csd = () => {
  const data = [
    // {
    //   subjectName: "2021 Batch",
    //   units: [ ],
    //   links: [
    //     {
    //       url: "",
    //       title: "Syllabus",
    //     },
    //   ],
    // },
    {
      subjectName: "2022 Batch",
      units: [],
      links: [
        {
          url: "https://drive.google.com/file/d/13o6pCzC2rcqJeRp5-cqN01cgmV--8uRL/view?usp=sharing",
          title: "Syllabus",
        },
      ],
    },
    ];
  return (
    <div className="min-h-screen pt-12 m-auto w-[90%]">
      <h1 className="text-xl font-semibold flex justify-center">CSD Sem - 2</h1>
      <Accordions data={data} />
    </div>
  );
};

export default Sem2Csd